import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";
import { VNode } from "vue/types/umd";
import { Tooltip, Progress } from "ant-design-vue";
import { TooltipProps } from "ant-design-vue/lib/tooltip";

@Component({
	components: {
		Tooltip,
		Progress
	}
})
export default class ActionItem extends Vue {
	@Prop() icon?: string;
	@Prop() text?: string;
	@Prop() tooltip?: string | VNode;
	@Prop() tooltipOptions?: TooltipProps;
	@Prop() disabled?: boolean;
	@Prop() progress?: number;
	@Prop() route?: string;
	@Prop() iconClass?: string;
	@Prop() customClass?: string;

	get progressStatus(): string {
		return this.progress === 100 ? "success" : "active";
	}

	get hasClickListener(): boolean {
		return !!this.$listeners?.click;
	}

	public get listeners(): Record<string, Function | Function[]> {
		const { click, ...rest } = this.$listeners;
		return rest;
	}

	public onClick(event: MouseEvent) {
		if (this.disabled) {
			return;
		}

		this.$emit("click", event);
	}
}
